// 展示会コレクション。quick-view 自体はテーマ既定の $store.quickview / product.js に委ね、
// ここは追従バー・タブ・ヘッダーの回遊抑制だけを担当する。

// 対象別に exhibition-b2b-jp 等へ分岐するため前方一致で拾う
var isExhibition = (document.body.dataset.templateSuffix || '').indexOf('exhibition') === 0;

if (isExhibition) {
  injectAccountLink();
  disableLogoLink();
  fixQuickViewMobileAddToCart();
  closeQuickViewAfterAddToCart();
  redirectCartDrawerToCartBar();
}

// 展示会のカートは追従バーで完結させる。cart_type = drawer の店では
// カートに追加するたびにカートドロワーが開き、バーと二重の UI になる。
// cart モーダルの open を横取りしてバーの展開へ振り替える。
// 要素ごと消したり open を握り潰したりすると、ヘッダーのカートボタンが
// 無反応になったり product.js のカート更新経路が壊れたりする。
function redirectCartDrawerToCartBar() {
  // modals ストアは modals.js が alpine:init で登録する。この関数は
  // それより先に走るため、初期化完了後に差し替える
  document.addEventListener('alpine:initialized', () => {
    const modals = window.Alpine && window.Alpine.store('modals');
    if (!modals) return;

    const open = modals.open.bind(modals);
    modals.open = (name) => {
      if (name !== 'cart') return open(name);

      const bar = document.querySelector('exhibition-cart-bar');
      // バーが無いページ（想定外）ではテーマ既定の挙動に戻す
      if (!bar) return open(name);
      bar.setOpen(true);
    };
  });
}

// 展示会はトップへ回遊させないため、ヘッダーのロゴをリンクから外す。
// href を落として遷移を止め、キーボードの空タブ止まりも作らない
// （CSS 側でも pointer-events を切ってあり、JS 実行前のクリックはそちらで止まる）
function disableLogoLink() {
  document.querySelectorAll('[data-theme-header] .font-heading > a').forEach(function (link) {
    link.removeAttribute('href');
    link.removeAttribute('rel');
    link.tabIndex = -1;
  });
}

// 展示会テンプレートはヘッダーのメニューを隠すためログイン導線が消える。
// ヘッダーのアカウントリンクは「デスクトップでドロワーメニューを使うか」の設定に紐づいており
// 展示会だけ出すことができない。既にリンクがあれば目印のクラスを付けて CSS で出し、
// 無ければセクションが用意した <template> をユーティリティ列の先頭へ差し込む。
function injectAccountLink() {
  var header = document.querySelector('[data-theme-header]');
  if (!header) return;

  // ユーティリティ列（ロゴの反対側にログイン / カートを並べる場所）。
  // メニューの .lg\:justify-end とはクラストークンが別なので取り違えない
  var utility = header.querySelector('.justify-end');
  if (!utility) return;

  var existing = utility.querySelector('a[href*="/account"]');
  if (existing) {
    existing.classList.add('c_js-exhibition-account-link');
    return;
  }

  var template = document.getElementById('ExhibitionAccountLink');
  if (!template || utility.querySelector('.c_js-exhibition-account-link')) return;

  utility.insertBefore(template.content.firstElementChild.cloneNode(true), utility.firstElementChild);
}

// quick-view のモバイル追従「カートに追加」は product.js の mobileAddToCartClick が
// cart_type = drawer 前提で、それ以外では @click.prevent だけが効いて何も起きない。
// 展示会はモバイルからの発注が主動線のため、drawer 以外のときだけフォーム送信で補う。
// form 属性を持つ add-to-cart はこの追従ボタンだけで、フォーム内の通常ボタンとは重複しない。
function fixQuickViewMobileAddToCart() {
  if (window.theme && window.theme.settings && window.theme.settings.cart_type === 'drawer') return;

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var button = event.target.closest('#quick-view-drawer-slot .add-to-cart-btn[form]');
    if (!button || button.disabled) return;

    var form = document.getElementById(button.getAttribute('form'));
    if (form) form.dispatchEvent(new Event('submit'));
  });
}

// cart_type = drawer 以外ではカートに追加してもドロワーが閉じず、追加された確認も出ない
// （確認テキストは drawer 前提の条件で描画される）。追従バーを見せるため展示会では閉じる。
function closeQuickViewAfterAddToCart() {
  window.addEventListener('switch:cart:afteradditem', function () {
    if (!window.Alpine) return;
    var modals = window.Alpine.store('modals');
    if (modals) modals.close('productQuickView');
  });
}

if (!customElements.get('exhibition-cart-bar')) {
  customElements.define(
    'exhibition-cart-bar',
    class ExhibitionCartBar extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.open = false;
        this.onCartUpdate = this.onCartUpdate.bind(this);
        this.addEventListener('click', this.onClick.bind(this));
      }

      connectedCallback() {
        // 他 UI（ヘッダーの個数バッジ等）と同じイベントで追従する
        window.addEventListener('switch:cart:afteradditem', this.onCartUpdate);
        window.addEventListener('switch:modalcart:cartqtychange', this.onCartUpdate);
      }

      disconnectedCallback() {
        window.removeEventListener('switch:cart:afteradditem', this.onCartUpdate);
        window.removeEventListener('switch:modalcart:cartqtychange', this.onCartUpdate);
      }

      onCartUpdate(event) {
        // 自分が起点の更新は応答の中に自分のセクションが入っているため再取得しない
        if (event.detail && event.detail.source === 'exhibition-cart-bar') return;
        this.refresh();
      }

      onClick(event) {
        const toggle = event.target.closest('.c_js-cart-bar-toggle');
        if (toggle) {
          this.setOpen(!this.open);
          return;
        }

        const qtyButton = event.target.closest('.c_js-cart-bar-qty');
        if (qtyButton) {
          this.changeLine(qtyButton.dataset.cartItemKey, parseInt(qtyButton.dataset.quantity, 10));
          return;
        }

        const removeButton = event.target.closest('.c_js-cart-bar-remove');
        if (removeButton) {
          this.changeLine(removeButton.dataset.cartItemKey, 0);
        }
      }

      setOpen(open) {
        this.open = open;
        const panel = this.querySelector('.c_p-collection-exhibition-cart-bar__panel');
        const toggle = this.querySelector('.c_js-cart-bar-toggle');
        if (panel) panel.hidden = !open;
        if (toggle) toggle.setAttribute('aria-expanded', String(open));
        this.classList.toggle('is-open', open);
      }

      changeLine(id, quantity) {
        this.setBusy(true);

        const config = fetchConfigDefaults('application/javascript');
        config.body = JSON.stringify({
          id,
          quantity,
          sections: this.dataset.refreshSections,
          sections_url: window.location.pathname,
        });

        fetch(theme.routes.cart_change_url, config)
          .then((response) => response.json())
          .then((data) => {
            if (data.sections && data.sections[this.sectionId]) {
              this.renderFromHTML(data.sections[this.sectionId]);
            }
            // ヘッダーの個数バッジやカートドロワーもテーマ既定の経路で更新させる
            document.body.dispatchEvent(
              new CustomEvent('switch:modalcart:cartqtychange', {
                bubbles: true,
                detail: { response: data, originalTarget: this, source: 'exhibition-cart-bar' },
              })
            );
          })
          .catch((error) => console.error(error))
          .finally(() => this.setBusy(false));
      }

      refresh() {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.sectionId);

        fetch(url.toString())
          .then((response) => response.text())
          .then((text) => this.renderFromHTML(text))
          .catch((error) => console.error(error));
      }

      renderFromHTML(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector('exhibition-cart-bar');
        if (!fresh) return;

        this.innerHTML = fresh.innerHTML;
        this.classList.toggle('is-active', fresh.classList.contains('is-active'));
        // 再描画後も展開状態を維持する
        this.setOpen(this.open && this.classList.contains('is-active'));
      }

      setBusy(busy) {
        // toggleAttribute は aria-busy="" になり CSS の [aria-busy='true'] に一致しない
        if (busy) this.setAttribute('aria-busy', 'true');
        else this.removeAttribute('aria-busy');
      }
    }
  );
}

if (!customElements.get('exhibition-tabs')) {
  customElements.define(
    'exhibition-tabs',
    class ExhibitionTabs extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
      }

      get tabs() {
        return Array.from(this.querySelectorAll('[role="tab"]'));
      }

      onClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(tab);
      }

      onKeydown(event) {
        const tabs = this.tabs;
        const current = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        if (current < 0) return;

        let next = null;
        if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;

        event.preventDefault();
        this.select(tabs[next]);
      }

      select(tab) {
        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.classList.toggle('is-active', selected);
          if (selected) item.removeAttribute('tabindex');
          else item.setAttribute('tabindex', '-1');

          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });

        // Safari はクリックしてもボタンにフォーカスを与えない。移しておかないと直後の矢印キーが keydown に届かない
        tab.focus();
      }
    }
  );
}
